import Axios from 'axios';
import Qs from 'qs';

export default {

  // 会员分页列表
  listPage(
    nickname,
    mobile,
    time_start,
    time_end,
    state,
    page,
    limit
  ) {
    return Axios.get('/community/api/admin/app-users', {
      params: {
        filter: {
          nickname,
          mobile,
          state
        },
        time_start,
        time_end,
        page,
        limit
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    });
  },

  // 会员信息
  info(
    id
  ) {
    return Axios.get(`/community/api/admin/app-users/${id}`);
  },

  // 启用会员
  enable(
    id
  ) {
    return Axios.post(`/community/api/admin/app-users/enable/${id}`);
  },

  // 禁用会员
  disable(
    id
  ) {
    return Axios.post(`/community/api/admin/app-users/disable/${id}`);
  },

}